import { action, computed, makeObservable } from 'mobx';

import { IFormFieldOptions } from '@/stores/interfaces/IFormField';

import { FieldStore } from '../FieldStore';

type ToServerData = boolean | null;

interface FieldCheckedOpts extends Partial<IFormFieldOptions<boolean>> {
  omitFalse?: boolean;
}

export class FieldCheckedStore extends FieldStore<boolean> {
  private readonly _omitFalse: boolean;

  constructor({ omitFalse = false, ...options }: FieldCheckedOpts = {}) {
    super({ ...options, defaultValue: Boolean(options?.defaultValue) });
    this._omitFalse = omitFalse;

    makeObservable(this, {
      serverFormat: computed,
      setFromServerFormat: action.bound,
    });
  }

  /** Заполняет значение поле из серверных данных **/
  setFromServerFormat(from: boolean | null): void {
    this.setValue(Boolean(from), { noTouch: true });
  }

  setFromQueryFormat(from: string | boolean): void {
    this.setFromServerFormat(String(from) === 'true');
  }

  /** Значение поле в серверном формате **/
  get serverFormat(): ToServerData {
    return this._omitFalse ? (this.value ? true : null) : this.value;
  }
}
